<template>
  <div class="input-radio-select">
    <div class="input-radio-select__icon">
      <fa v-if="icon" :icon="icon" fixed-width />
    </div>  
    <div class="input-radio-select__buttons">
      <div 
        class="input-radio-select__button-wrapper"
        v-for="selection in selections"
        :key="selection.value"
        @click="emitSelection(selection.value)"
      >
        <button
          class="touch"
          :class="[
            { 'active': selection.value === value },
            { 'disabled': selection.disabled }
          ]"
        >
          {{ selection.label }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [ 'icon', 'selections', 'value'],

  methods: {
    emitSelection (value) {
      if (this.value === value) {
        this.$emit('input', false)
      } else {
        this.$emit('input', value)
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";

.input-radio-select {
  align-items: center;
  display: flex;
  justify-content: flex-start;
  width: 15rem;

  &__icon {
    font-size: 2rem;

    svg {
      margin-right: 1rem;
    }
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -.2rem;
  }

  &__button-wrapper {
    font-size: 1.5rem;
    height: 3rem;
    padding: 0.2rem;
    width: 3rem;
    text-align: center;
    transition: background-color 0.15s ease-in;

    &--half {
      width: 7.5rem;
    }

    button {
      align-items: center;
      background: transparent;
      border: 0.1rem solid $white;
      border-radius: .5rem;
      display: flex;
      font-size: 1rem;
      font-weight: 100;
      justify-content: center;
      height: 100%;
      padding-top: .15rem;
      text-transform: uppercase;
      transition: background 50ms ease-out;
      width: 100%;

      &:active,
      &.active {
        background: $darklime;
      }

      &.disabled {
        opacity: .5;
        pointer-events: none !important;
      }
    }
  }
}
</style>

